// extracted by mini-css-extract-plugin
export default {"container":"GoBackHeaderMobile_container__2DpOG","goBack":"GoBackHeaderMobile_goBack__2McgJ","logo":"GoBackHeaderMobile_logo__3WYpB","bigTitle":"GoBackHeaderMobile_bigTitle__r511S"};